import { render, staticRenderFns } from "./AddMaterialPurchase.vue?vue&type=template&id=532df46c&"
import script from "./AddMaterialPurchase.vue?vue&type=script&lang=js&"
export * from "./AddMaterialPurchase.vue?vue&type=script&lang=js&"
import style0 from "./AddMaterialPurchase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports